import { create } from "zustand";
import { persist } from "zustand/middleware";

type ReferralState = {
  refCode: string | null;
  setRefCode: (refCode: string) => void;
  clearRefCode: () => void;
};

export const useReferralStore = create<ReferralState>()(
  persist(
    (set) => ({
      refCode: null,
      setRefCode: (refCode) => set({ refCode }),
      clearRefCode: () => set({ refCode: null }),
    }),
    {
      name: "referral-storage",
      partialize: (state) => ({ refCode: state.refCode }),
    }
  )
);
